module.exports = __webpack_public_path__ + "static/media/Picture4.98f25235.png";